import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { filter, take } from 'rxjs';
import { map } from 'rxjs/operators';
import { RequestStatus } from 'ngxs-requests-plugin';
import { DbVersionService } from '../services/dbVersion.service';


export const GetDbVersionResolver: ResolveFn<any> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const dbInfoService = inject(DbVersionService);

  // Check if the dbVersion is already loaded
  if (!!dbInfoService.GetLatestDbVersionSnapshot()?.dbVersion) {
    return true;
  }

  // Get the database info
  dbInfoService.GetLatestDbVersion();

  // Wait for the dbVersion to load
  return dbInfoService.GetLatestDbVersionRequestState$.pipe(
    filter(request => !!request),
    filter(({loaded, status}) => loaded && status === RequestStatus.Success),
    take(1),
    map(res => {
      return res.data;
    })
  );
}
